module.exports = __webpack_public_path__ + "img/dettaglio chiavi 2.53f7b51a.jpeg";